import BaseAPI from '@/apis/base/baseApi';

class WebsiteWideProfileAPI extends BaseAPI {
	constructor() {
		super();
	}
	apiName = 'Business';
	controllerName = 'websiteWideProfile';
}

export default new WebsiteWideProfileAPI();
